import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundScreen.css';

function NotFoundScreen() {
  return (
    <div className="not-found-screen">
      <div className="not-found-container">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Pagina non trovata</h2>
          <p className="not-found-message">
            Spiacenti, la pagina che stai cercando non esiste o è stata spostata.
          </p>
          <div className="not-found-actions">
            <Link to="/" className="btn-primary">
              Torna alla Home
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contattaci
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundScreen;
